"use client"

import { ChakraProvider } from "@chakra-ui/react"
import { system } from "@/theme/system"
import {
  ColorModeProvider,
  type ColorModeProviderProps,
} from "./color-mode"

// Afwijkingen van de CLI-snippet:
// - ons eigen `system` in plaats van `defaultSystem`;
// - altijd het lichte thema, want het origineel had geen donkere modus. De
//   props staan ervoor, zodat niemand `forcedTheme` per ongeluk overschrijft;
// - het inline script van next-themes als datablok. Dat script voorkomt een
//   flits bij server-rendering, die hier niet bestaat; in de browser draait het
//   nooit. Als JavaScript-type laat React 19 er in dev een console-fout voor zien.
export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider
        {...props}
        forcedTheme="light"
        scriptProps={{ type: "application/json" }}
      />
    </ChakraProvider>
  )
}
